<template>
    <div>
        <el-dialog title="Objetivos" :visible.sync="dialog" :before-close="handleCancel" width="500px">
            <el-form ref="goalForm" :model="goal" label-position="top">
                <el-row :gutter="20">
                    <el-form-item label="Fecha">
                        <el-date-picker v-model="goal.date" type="month" placeholder="Select date" clearable />
                    </el-form-item>
                    <el-form-item label="Nivel">
                        <el-select v-model="goal.level" placeholder="Select level" clearable>
                            <el-option-group v-for="(courses, level) in levels" :key="level">
                                <el-option v-for="course in courses" :key="course" :label="course" :value="course"></el-option>
                            </el-option-group>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCancel()">Cancelar</el-button>
                <el-button type="primary" @click="handleSubmit()">Confirmar</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ['dialog', 'enrolment_id', 'old_goal'],
    data() {
        return {
            data: {
                subject: '',
                message: '',
            },
            levels: {
                'A1': ['A1'],
                'A2': ['A2'],
                'B1': ['B1'],
                'B2': ['B2'],
                'C1': ['C1'],
                'C2': ['C2'],
            },
            goal: {
                id: 0,
                date: null,
                level: '',
                enrolment_id: 0,
            }
        }
    },
    created() {
        this.goal.enrolment_id = this.enrolment_id
        if (this.old_goal != null) {
            this.goal = this.old_goal
        }
    },
    methods: {
        handleSubmit() {
            if (this.goal.date == null || this.goal.level === '') {
                this.$message({
                    message: "Todos los campos son requeridos",
                    type: 'error',
                    duration: 5000,
                });
                return
            }
            if (this.goal.id == 0) {
                axios.post('goals', this.goal)
                    .then(res => {
                        this.$message({
                            message: res.data,
                            type: 'success',
                            duration: 5000,
                        });
                        this.handleCancel();
                    })
                    .catch(e => {
                        console.log(e.response);
                    })
            }
            else {
                axios.put('goals/' + this.goal.id, {
                    date: this.goal.date,
                    level: this.goal.level
                })
                    .then(res => {
                        this.$message({
                            message: res.data,
                            type: 'success',
                            duration: 5000,
                        });
                        this.handleCancel();
                    })
                    .catch(e => {
                        console.log(e.response);
                    })
            }
        },
        handleCancel(done) {
            this.$emit('dialog', false);
        },
    },
}
</script>
<style scoped>
.v-modal {
    z-index: 0 !important;
}

.el-form-item {
    max-width: 50%;
    display: inline-block;
}
</style>